import { useContext, useEffect, useState } from "react";
import { Menu, Sidebar, MenuItem } from "react-pro-sidebar";
import { useProSidebar } from "react-pro-sidebar";
import { useSidebarContext } from "./sidebarContext";
import { Link, useNavigate } from "react-router-dom";
import { Box, Typography, IconButton } from "@mui/material";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import UpdateDisabledOutlinedIcon from "@mui/icons-material/UpdateDisabledOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import AutoDeleteOutlinedIcon from "@mui/icons-material/AutoDeleteOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AuthContext from "../../CONTEXT/AuthProvider";
import "./sidebar.css";
import PersonSearchOutlined from "@mui/icons-material/PersonSearchOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';

const Item = ({ title, icon, selected, setSelected }) => {
  const { collapsed } = useProSidebar();
  const [isHovered, setIsHovered] = useState(false);
  const { auth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;

  return (
    <MenuItem
      active={selected === title}
      style={{
        color: !collapsed
          ? "#ffffff"
          : subscribername === "BANK OF TANZANIA"
          ? "#082FB0"
          : "#D30000",
        marginBottom: "25px",
        borderRadius: "3px",
        backgroundColor: collapsed
          ? "transparent"
          : subscribername === "BANK OF TANZANIA"
          ? "#082FB0"
          : "#D30000",
        position: "relative",
      }}
      onClick={() => setSelected(title)}
      icon={icon}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Typography
        style={{
          fontSize: "13px",
          fontFamily: "sans-serif",
          fontWeight: "bold",
        }}
      >
        {title}
      </Typography>

      {collapsed && isHovered && (
        <div className="menuitem-hover">
          <p>{title}</p>
        </div>
      )}
    </MenuItem>
  );
};

const MyProSidebar = () => {
  const { auth, setAuth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;
  const [selected, setSelected] = useState("Dashboard");
  const { sidebarImage } = useSidebarContext();
  const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();

  const navigate = useNavigate();

  const handleLogout = () => {
    setAuth({});
    navigate("/login");
  };

  useEffect(() => {
    collapseSidebar();
  }, []);

  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        bottom: 0,
        zIndex: 10000,
        "& .sidebar": {
          border: "none",
        },
        "& .menu-icon": {
          backgroundColor: "transparent !important",
        },
        "& .menu-item": {
          padding: "5px 35px 5px 20px !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-anchor": {
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-item:hover": {
          color: `${"#6870fa"} !important`,
          backgroundColor: "transparent !important",
        },
        "& .menu-item.active": {
          color: `${"#4cceac"} !important`,
          backgroundColor: "transparent !important",
        },
      }}
    >
      <Sidebar backgroundColor="#ffffff" image={sidebarImage}>
        <Menu iconshape="square">
          <MenuItem
            icon={
              collapsed && (
                <MenuOutlinedIcon onClick={() => collapseSidebar()} />
              )
            }
            style={{
              margin: "10px 0 20px 0",
              color: "#141414",
            }}
          >
            {!collapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography
                  variant="h6"
                  color="#666666"
                  overflow="hidden"
                  fontSize="12px"
                  fontWeight="bold"
                ></Typography>
                <IconButton
                  onClick={
                    broken ? () => toggleSidebar() : () => collapseSidebar()
                  }
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
          {!collapsed && (
            <Box mb="25px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  "& .avater-image": {
                    backgroundColor: "#141b2d",
                  },
                }}
              >
                {subscribername === "BANK OF TANZANIA" ? (
                  <img
                    src="/images/BOT.png"
                    style={{ width: "90%", height: "100%" }}
                    alt="logo"
                  />
                ) : (
                  <img
                    src="/images/logo.png"
                    style={{ width: "90%", height: "100%" }}
                    alt="logo"
                  />
                )}
              </Box>
            </Box>
          )}
          <Box padding={collapsed ? undefined : "5%"}>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Item
                title="Dashboard"
                icon={<HomeOutlinedIcon style={{ fontSize: "20px" }} />}
                selected={selected}
                setSelected={setSelected}
              />
            </Link>

            <hr />

            {auth.staff === "Yes" && auth.role === "admin" && (
              <>
                <Link to="/addSubscriber" style={{ textDecoration: "none" }}>
                  <Item
                    title="Add Subscriber"
                    icon={
                      <PersonAddAltOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link
                  to="/listofSubscribers"
                  style={{ textDecoration: "none" }}
                >
                  <Item
                    title="View Subscribers"
                    icon={
                      <PeopleAltOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/addUser" style={{ textDecoration: "none" }}>
                  <Item
                    title="Add User"
                    icon={
                      <PersonAddAltOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/listofUsers" style={{ textDecoration: "none" }}>
                  <Item
                    title="View Users"
                    icon={
                      <PeopleAltOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/listofStaffs" style={{ textDecoration: "none" }}>
                  <Item
                    title="View Staffs"
                    icon={
                      <PeopleAltOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/loghistory" style={{ textDecoration: "none" }}>
                  <Item
                    title="Logs"
                    icon={
                      <HistoryToggleOffOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>
              </>
            )}

            {auth.staff === "Yes" && auth.role === "admin" && <hr />}

            {auth.disputeManagement === "1" && (
              <>
                {auth.staff === "Yes" && auth.role === "admin" && (
                  <Link to="/addDisputes" style={{ textDecoration: "none" }}>
                    <Item
                      title="Update Disputes"
                      icon={
                        <ControlPointOutlinedIcon
                          style={{ fontSize: "20px" }}
                        />
                      }
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Link>
                )}

                <Link to="/activeDisputes" style={{ textDecoration: "none" }}>
                  <Item
                    title="Active Disputes"
                    icon={<LockOpenOutlinedIcon style={{ fontSize: "20px" }} />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/closedDisputes" style={{ textDecoration: "none" }}>
                  <Item
                    title="Closed Disputes"
                    to="/faq"
                    icon={<LockOutlinedIcon style={{ fontSize: "20px" }} />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/searchedDisputes" style={{ textDecoration: "none" }}>
                  <Item
                    title="Assess Closed Disputes"
                    to="/faq"
                    icon={
                      <AssessmentOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <hr />

                {auth.staff === "Yes" && auth.role === "admin" && (
                  <Link
                    to="/addNonUpdatedContracts"
                    style={{ textDecoration: "none" }}
                  >
                    <Item
                      title="Add Non Updated Contracts"
                      icon={
                        <ControlPointOutlinedIcon
                          style={{ fontSize: "20px" }}
                        />
                      }
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Link>
                )}

                <Link
                  to="/nonUpdatedContracts"
                  style={{ textDecoration: "none" }}
                >
                  <Item
                    title="Non Updated Contracts"
                    to="/faq"
                    icon={
                      <UpdateDisabledOutlinedIcon
                        style={{ fontSize: "20px" }}
                      />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <hr />

                {auth.staff === "Yes" && auth.role === "compliance" && (
                  <Link to="/deletionForm" style={{ textDecoration: "none" }}>
                    <Item
                      title="Add Deletion Request"
                      icon={
                        <DeleteForeverOutlinedIcon
                          style={{ fontSize: "20px" }}
                        />
                      }
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Link>
                )}

                <Link to="/deletionRequests" style={{ textDecoration: "none" }}>
                  <Item
                    title="Deletion Requests"
                    icon={
                      <AutoDeleteOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <hr />
              </>
            )}

            {auth.nameLookup === "1" && (
              <>
                <Link to="/new-search" style={{ textDecoration: "none" }}>
                  <Item
                    title="New Search"
                    icon={<SearchOutlinedIcon style={{ fontSize: "20px" }} />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/search-History" style={{ textDecoration: "none" }}>
                  <Item
                    title="Search History"
                    icon={<PersonSearchOutlined style={{ fontSize: "20px" }} />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <Link to="/assess-report" style={{ textDecoration: "none" }}>
                  <Item
                    title="Assess Report"
                    icon={
                      <AssessmentOutlinedIcon style={{ fontSize: "20px" }} />
                    }
                    selected={selected}
                    setSelected={setSelected}
                  />
                </Link>

                <hr />
              </>
            )}

            <Link onClick={handleLogout} style={{ textDecoration: "none" }}>
              <Item
                title="Logout"
                icon={<ExitToAppIcon style={{ fontSize: "20px" }} />}
                selected={selected}
                setSelected={setSelected}
              />
            </Link>
          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default MyProSidebar;
